import React from 'react';
import { Link } from 'react-router-dom';
import { clientLogos, industries } from '../mock';

export const LogosStrip = () => (
  <section className="py-14 bg-white border-y border-slate-100">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <h3 className="text-center text-slate-500 uppercase tracking-widest text-xs font-semibold mb-8">Trusted by growing brands worldwide</h3>
      <div className="relative overflow-hidden">
        <div className="flex gap-14 animate-[scroll_30s_linear_infinite] whitespace-nowrap">
          {[...clientLogos, ...clientLogos, ...clientLogos].map((name, i) => (
            <div key={i} className="flex-shrink-0 flex items-center justify-center min-w-[180px] h-16 text-slate-400 font-bold text-xl grayscale hover:grayscale-0 hover:text-[#E63946] transition-all">
              {name}
            </div>
          ))}
        </div>
      </div>
    </div>
    <style>{`@keyframes scroll { from { transform: translateX(0); } to { transform: translateX(-33.33%); } }`}</style>
  </section>
);

export const CTABanner = ({ text, cta = "Let's Talk SaaS" }) => (
  <section className="py-16" style={{ background: 'linear-gradient(90deg, #ded4f5 0%, #d5e5f7 50%, #e5daf4 100%)' }}>
    <div className="max-w-6xl mx-auto px-5 lg:px-8 flex flex-col lg:flex-row items-center gap-8 justify-between">
      <h3 className="text-2xl md:text-[32px] font-bold text-slate-900 leading-tight max-w-2xl">{text}</h3>
      <Link to="/#contact" className="bg-[#E63946] hover:bg-[#d02b38] text-white font-semibold px-8 py-4 rounded-full shadow-lg shadow-red-200/50 transition-colors whitespace-nowrap">{cta}</Link>
    </div>
  </section>
);

export const IndustriesSection = () => (
  <section className="py-20 bg-white">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <h2 className="text-center text-[30px] md:text-[42px] font-bold text-slate-900">SaaS Solutions for Leading Industries</h2>
      <p className="mt-4 text-center text-slate-600 max-w-3xl mx-auto">We develop SaaS platforms powered by the latest technology to drive efficiency and innovation across the software as a service industry.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
        {industries.map((ind) => (
          <div key={ind.title} className="bg-white rounded-2xl p-7 border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.04)] hover:shadow-[0_16px_40px_rgba(230,57,70,0.1)] hover:-translate-y-1 transition-all duration-300">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center flex-shrink-0">
                <ind.icon className="w-5 h-5 text-[#E63946]" />
              </div>
              <h3 className="text-[20px] font-bold text-slate-900 mt-1">{ind.title}</h3>
            </div>
            <ul className="space-y-2 text-slate-600 text-[14.5px] pl-2">
              {ind.points.map((p) => (
                <li key={p} className="list-disc list-inside marker:text-[#E63946]">{p}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </section>
);
